import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"icon-play\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 1h76a1 1 0 0 1 1 1v76a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1ZM0 2a2 2 0 0 1 2-2h76a2 2 0 0 1 2 2v76a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2Zm32.5 50.99L55 40 32.5 27.01v25.98Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol